import { useEffect, useState } from "react";
import { Card, Form, Input, Button, message, Switch, Typography } from "antd";
import {
  isAdminMeterAllowNegativeRemain,
  setAdminMeterAllowNegativeRemain,
} from "../../utils/adminMeterLocalFlags";
import { getAdminTutorialVideos, saveAdminTutorialVideos } from "../../api";
// 先注释接口，保留静态页面，后续对接后端再打开
// import { getBaseSetting, saveBaseSetting } from "../api";

const { Text } = Typography;

export default function SettingBase() {
  const [form] = Form.useForm();
  const [tutorialForm] = Form.useForm();
  const [allowNegativeRemain, setAllowNegativeRemain] = useState(false);
  const [tutorialSaving, setTutorialSaving] = useState(false);
  const [tutorialPreview, setTutorialPreview] = useState({ fangdong: "", zuke: "" });

  // 临时注释接口调用，避免报错（静态页面）
  useEffect(() => {
    // 对接后端时打开：getBaseSetting().then(form.setFieldsValue);
    // 可先设置默认值
    form.setFieldsValue({
      siteName: "云交租",
      record: "粤ICP备12345678号"
    });
    setAllowNegativeRemain(isAdminMeterAllowNegativeRemain());
    getAdminTutorialVideos()
      .then((res) => {
        const data = res?.data || {};
        const fangdong = data.fangdong || "";
        const zuke = data.zuke || "";
        tutorialForm.setFieldsValue({ fangdong, zuke });
        setTutorialPreview({ fangdong, zuke });
      })
      .catch(() => {});
  }, [form, tutorialForm]);

  const onFinish = (values) => {
    // 临时提示，对接后端时替换为接口调用
    // saveBaseSetting(values).then(() => message.success("已保存"));
    message.success("保存成功（静态页面，仅做展示）");
    console.log("基础设置保存值：", values);
  };

  const onSaveTutorial = async (values) => {
    setTutorialSaving(true);
    try {
      const res = await saveAdminTutorialVideos({
        fangdong: String(values.fangdong || "").trim(),
        zuke: String(values.zuke || "").trim(),
      });
      if (!res?.success) {
        message.error(res?.error || res?.msg || "保存失败");
        return;
      }
      const data = res.data || {};
      tutorialForm.setFieldsValue({
        fangdong: data.fangdong || "",
        zuke: data.zuke || "",
      });
      setTutorialPreview({
        fangdong: data.fangdong || "",
        zuke: data.zuke || "",
      });
      message.success("教程地址已保存，小程序下次打开教程页即生效");
    } catch (err) {
      const body = err.response?.data;
      message.error(body?.error || body?.msg || err.message || "保存失败");
    } finally {
      setTutorialSaving(false);
    }
  };

  const onAllowNegativeChange = (checked) => {
    setAdminMeterAllowNegativeRemain(checked);
    setAllowNegativeRemain(checked);
    message.success(checked ? "已开启：电表补电量可写负剩余（仅本机）" : "已关闭：电表目标剩余最多到 0（仅本机）");
  };

  return (
    <div>
      <h2>⚙️ 基础设置</h2>
      <Card style={{ maxWidth: 600, marginBottom: 16 }}>
        <Form 
          form={form} 
          layout="vertical" 
          onFinish={onFinish}
          initialValues={{
            siteName: "租房管理系统",
            record: "粤ICP备12345678号"
          }}
        >
          <Form.Item
            label="站点名称"
            name="siteName"
            rules={[{ required: true, message: "请输入站点名称" }]}
          >
            <Input placeholder="请输入站点名称" />
          </Form.Item>
          <Form.Item 
            label="备案号" 
            name="record"
            rules={[{ required: false }]}
          >
            <Input placeholder="请输入网站备案号" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="小程序使用教程" style={{ maxWidth: 600, marginBottom: 16 }}>
        <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 12 }}>
          分别填写转码后的 HTTPS CDN 地址。留空则对应端显示「教程准备中」。换片只需改地址，不用发小程序。
        </Text>
        <Form form={tutorialForm} layout="vertical" onFinish={onSaveTutorial}>
          <Form.Item label="房东端教程地址" name="fangdong">
            <Input placeholder="https://你的CDN/room-video/transcode/xxx.mp4" allowClear />
          </Form.Item>
          {tutorialPreview.fangdong ? (
            <video src={tutorialPreview.fangdong} controls style={{ width: "100%", marginBottom: 16, background: "#000" }} />
          ) : null}
          <Form.Item label="租客端教程地址" name="zuke">
            <Input placeholder="https://你的CDN/room-video/transcode/xxx.mp4" allowClear />
          </Form.Item>
          {tutorialPreview.zuke ? (
            <video src={tutorialPreview.zuke} controls style={{ width: "100%", marginBottom: 16, background: "#000" }} />
          ) : null}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={tutorialSaving}>
              保存教程地址
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="电表操作开关（仅本浏览器）" style={{ maxWidth: 600 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <div>
            <div style={{ fontWeight: 500 }}>允许补电量写负剩余</div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              默认关闭：目标剩余最低为 0。开启后可在电表「更改剩余 / 减少」写负数。只保存在本机本浏览器。
            </Text>
          </div>
          <Switch checked={allowNegativeRemain} onChange={onAllowNegativeChange} />
        </div>
      </Card>
    </div>
  );
}
